import { Component, Input, inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule, NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-autobid-dialog',
  templateUrl: './autobid-dialog.component.html',
  styleUrls: ['./autobid-dialog.component.scss'],
  standalone: true,
  imports: [FormsModule, NgIf, TranslatePipe],
})
export class AutobidDialogComponent {
  @Input() isMemorabid: boolean = true;
  @Input() inPreEventStatus: boolean = false;
  @Input() minimumOffer: number;
  @Input() rebidMaxOfferPrice: number | null;

  showErrorString = '';

  activeModal = inject(NgbActiveModal);

  makeAutoBid(formAutoBid: NgForm) {
  const amount: number = formAutoBid.value.autoBid;
    if(amount == null || amount < this.minimumOffer) {
      this.showErrorString = 'IDS_LESS_THAN_MINIMUM_RAISE';
      if (amount < this.rebidMaxOfferPrice) {
        this.showErrorString = 'IDS_ERROR_PRICEFAIL';
      }
    } else {
      this.activeModal.close(amount);
    }
  }

}
